import React, { useContext } from 'react';
import styled from 'styled-components';
import Headline from '../Headline';
import { ResultsView, ResultsViewContext } from '../../../utils/results-view-context';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import { VehicleContext } from '../../../utils/vehicle-context';

const CardHeadContainer = styled.div<{view: ResultsView}>`
  grid-area: model;

  ${props => props.view == ResultsView.LIST && `
    @media screen and (min-width: ${Breakpoints.b960}px) {
      margin-left: 36px;
    }
  `}
`;

const CardHead: React.FC = () => {
  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext);
  return (
    <CardHeadContainer view={view}>
      {vehicle && <Headline vehicle={vehicle} />}
    </CardHeadContainer>
  );
};

export default CardHead;
